<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <div>
            <b-button variant="secondary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.bic.bic_group_add')}}</span>
            </b-button>
          </div>
        </b-row>
        <b-row class="justify-content-between align-items-center mb-5" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-col sm="3" class="form-group">
          <!-- Filtre GroupName -->
            <form-write-group-label-input v-model="GroupName"
              :inputLabel="$t('common.bic.group_name')"
              @input="applyFilter">
            </form-write-group-label-input>
          </b-col>
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="2" class="d-flex justify-content-end">
            <b-button class="btn mr-3" size="sm"
              @click="clearFilterFields"
              :disabled="!GroupName">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
            <!-- <b-button class="btn" size="sm"
              @click="applyFilter">
              {{ $t('common.srch') }}
            </b-button> -->
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsBicGroup.length > 0"
              :items="listItemsBicGroup"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsBicGroup.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowClicked"
              :key="refreshKey">
              <template #cell(GroupName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdBicGroup)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdBicGroup)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "BicGroupPage",
  components: {
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      GroupName: '',
      listItemsBicGroup: [],
      listTitle: "",
      refreshKey: false,
      sortBy: 'GroupName'
    }
  },
  created() {
    this.listTitle = this.$i18n.t("common.bic.bic_group_list")
    this.activateSpinner = true
    this.getBicGroup()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      fields.push({
        key: 'GroupName',
        label: this.$t('common.bic.group_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/bic/bicGroup/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.bic.bicGroup.delete(params)
              .then(resp => {
                that.listItemsBicGroup = that.listItemsBicGroup.filter(item => item.IdBicGroup !== id)
                that.$f7.modal({
                  title: that.$t('common.bic.bic_group_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: 'bic/bicGroup/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_group_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/bic/bicGroup/edit/' + id })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getBicGroup()
    },
    clearFilterFields () {
      this.GroupName = ''
      // this.applyFilter()
    },
    getBicGroup () {
      let that = this
      let params = { GroupName: this.GroupName }
      this.$engine.bic.bicGroup.fetch(params).then((resp) => {
        let bicGroupList = {}

        bicGroupList = resp.data.BicGroup || []

        that.updateBicGroup(bicGroupList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getBicGroup()
    },
    onRowClicked (item) {
      const bicGroupId = item[0].IdBicGroup
      loadPage(this, { url: 'bic/bic/' + bicGroupId })
    },
    updateBicGroup (bicGroupList) {
      this.listItemsBicGroup = bicGroupList
    }
  }
}
</script>
